import React, { useEffect, useState } from 'react'
import schoolLogo from '../../Assets/founder1.jpg'
import schoolLogo2 from '../../Assets/founder2.jpeg'
import QRImg from '../../Assets/PaymentQrCode.jpeg'
import {
  Input,
  DatePicker,
  Select,
  Card,
  Row,
  Col,
  Button,
  message,
} from 'antd'
import axios from 'axios'
import '../../App.css'
import { toast } from 'react-toastify'
import Header from '../CommonComponent/Header'
import Footer from '../CommonComponent/Footer'
import { StudentRegFeeFormAPI } from '../../AllAPI/StudentAPI'
import dayjs from 'dayjs'
import { useNavigate } from 'react-router-dom'

const { Option } = Select

const RegFeeForm = () => {
  const [fileKey, setFileKey] = useState(Date.now())

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  const [step, setStep] = useState(1) // Step 1 = Form, Step 2 = Payment
  const navigate = useNavigate()
  // All form states
  const [memberId, setMemberId] = useState('')
  const [FName, setFName] = useState('')
  const [MName, setMName] = useState('')
  const [LName, setLName] = useState('')
  const [studentName, setStudentName] = useState('')
  const [email, setEmail] = useState('')
  const [gender, setGender] = useState('')
  const [mobile, setMobile] = useState('')
  const [changedName, setChangedName] = useState('')
  const [dob, setDob] = useState(null)
  const [bloodGroup, setBloodGroup] = useState('')
  const [dropoutClass, setDropoutClass] = useState('')
  const [education, setEducation] = useState('')
  const [occupation, setOccupation] = useState('')
  const [entryType, setEntryType] = useState('')
  const [houseNo, setHouseNo] = useState('')
  const [confirmationForJoining, setConfirmationForJoining] = useState('')
  const [sendingArticlePoems, setSendingArticlePoems] = useState('')
  const [wayOfAttending, setWayOfAttending] = useState('')
  const [registrationFee, setRegistrationFee] = useState(800)
  const [studentNewImage, setStudentNewImage] = useState(null)
  const [studentOldImage, setStudentOldImage] = useState(null)
  const [loader, setLoader] = useState(false)

  // Payment
  const [paymentScreenshot, setPaymentScreenshot] = useState(null)

  // REQUIRED FIELDS LIST
  const requiredFields = [
    { value: studentName, label: 'Student Name' },
    { value: mobile, label: 'Mobile Number' },
    { value: dob, label: 'Date of Birth' },
    { value: email, label: 'Email' },
    { value: gender, label: 'Gender' },
    { value: bloodGroup, label: 'Blood Group' },
    { value: dropoutClass, label: 'Passout Class' },
    { value: education, label: 'Education' },
    { value: occupation, label: 'Occupation' },
    { value: entryType, label: 'Type of Entry' },
    { value: houseNo, label: 'House No.' },
    { value: confirmationForJoining, label: 'Joining Confirmation' },
    { value: sendingArticlePoems, label: 'Article/Poem Confirmation' },
    { value: wayOfAttending, label: 'Way of Attending' },
    { value: studentNewImage, label: 'Student New Image' },
    { value: studentOldImage, label: 'Student Old Image' },
  ]

  useEffect(() => {
    const saved = JSON.parse(sessionStorage.getItem('userData'))
    if (saved) {
      setFName(saved.fname)
      setMName(saved.mname)
      setLName(saved.lname)
      setStudentName(`${saved.fname} ${saved.mname} ${saved.lname}`)
      setMobile(saved.mobile)
      setEmail(saved.email)
      setMemberId(saved.member_id)
    }
  }, [])

  useEffect(() => {
    const today = new Date()
    const deadline = new Date('2026-01-24') // 24 Jan 2026

    if (today > deadline) {
      setRegistrationFee(1000) // After 24 Jan
    } else {
      setRegistrationFee(800) // Before or on 31 Dec
    }
  }, [])

  // ================================
  // ❌ STEP 1 → NEXT BUTTON VALIDATION
  // ================================
  const handleNext = () => {
    for (let field of requiredFields) {
      if (!field.value || field.value === '') {
        toast.error(`${field.label} is required`)
        return
      }
    }
    setStep(2) // Go to Payment Section

    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  // ================================
  // FINAL SUBMIT (FormData)
  // ================================
  const handleSubmit = async () => {
    if (!paymentScreenshot) {
      message.error('Please upload payment screenshot!')
      return
    }

    const formData = new FormData()
    formData.append('member_id', memberId)
    formData.append('fname', FName)
    formData.append('mname', MName)
    formData.append('lname', LName)
    formData.append('gender', gender)
    formData.append('mobile', mobile)
    formData.append('email', email)
    formData.append('changed_name', changedName)
    formData.append('date_of_birth', dob ? dayjs(dob).format('YYYY-MM-DD') : '')
    formData.append('blood_group', bloodGroup)
    formData.append('school_dropout_year', dropoutClass)
    formData.append('education', education)
    formData.append('occupation', occupation)
    formData.append('entry_type', entryType)
    formData.append('house_number', houseNo)
    formData.append('confirmation_for_joining', confirmationForJoining)
    formData.append('sending_articles', sendingArticlePoems)
    formData.append('way_of_attending', wayOfAttending)
    formData.append('payment_amount', registrationFee)
    formData.append('s_pic', studentNewImage)
    formData.append('old_pic', studentOldImage)
    formData.append('payment_screenshot', paymentScreenshot)

    try {
      setLoader(true)
      const res = await axios.post(StudentRegFeeFormAPI, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })

      if (res.data === 'ERROR') {
        toast.warn('Some Error Occurred!')
      } else if (res.data === 'SAVED') {
        toast.success('Registration Submitted Successfully!')
        navigate('/')
      }
    } catch (error) {
      console.log(error)
      toast.error('Something went wrong!')
    }
    setLoader(false)
  }

  // =================================================================

  return (
    <div className="bg-gray-100 min-h-screen">
      <Header />

      <div className="row m-0 p-md-5">
        <div className="col-12 col-md-2"></div>
        <div className="col-12 col-md-8 pb-5">
          {/* STEP INDICATOR */}
          <header className="bg-blue-600 text-start py-3 px-3 rounded-lg shadow-md">
            <h4 className="font-bold">
              {step === 1 ? 'Student Information' : 'Payment Section'}
            </h4>
          </header>

          {/* ================= Main Card ================ */}
          <div className="flex justify-center pb-5">
            <Card className="w-full max-w-3xl shadow-lg rounded-xl border">
              <Row gutter={16} className="">
                {/* Student Name */}
                {step === 1 && (
                  <>
                    <Col sm={24} md={12} className="mt-3">
                      <label className="font-semibold">Student Name</label>
                      <Input
                        value={studentName}
                        // onChange={(e) => setStudentName(e.target.value)}
                        placeholder="Enter student name"
                        className="mt-1"
                        required
                        disabled
                      />
                    </Col>
                    {/* Changed Name */}
                    <Col sm={24} md={12} className="mt-3">
                      <label className="font-semibold">
                        Changed Name (Only For Girls)
                      </label>
                      <Input
                        required
                        value={changedName}
                        onChange={(e) => setChangedName(e.target.value)}
                        placeholder="Enter changed name"
                        className="mt-1"
                      />
                    </Col>
                    {/* Mobile Number */}
                    <Col sm={24} md={8} className="mt-3">
                      <label className="font-semibold">Mobile Number</label>
                      <Input
                        required
                        value={mobile}
                        // onChange={(e) => {
                        //   const val = e.target.value.replace(/\D/g, '') // REMOVE all non-digits
                        //   setMobile(val)
                        // }}
                        placeholder="Enter mobile number"
                        maxLength={10}
                        className="mt-1"
                        disabled
                      />
                    </Col>
                    {/* Email Id */}
                    <Col sm={24} md={8} className="mt-3">
                      <label className="font-semibold">Email</label>
                      <Input value={email} disabled className="mt-1" />
                    </Col>
                    {/* Date of Birth */}
                    <Col sm={24} md={8} className="mt-3 w-100">
                      <label className="font-semibold">Date of Birth</label>{' '}
                      <br />
                      <DatePicker
                        required
                        className="w-100 mt-1"
                        format="DD-MM-YYYY"
                        onChange={(date) => setDob(date)}
                      />
                    </Col>
                    {/* Blood Group */}
                    <Col sm={24} md={8} className="mt-3 w-100">
                      <label className="font-semibold">Blood Group</label>
                      <Select
                        required
                        className="w-100 mt-1"
                        placeholder="Select type"
                        onChange={(value) => setBloodGroup(value)}
                      >
                        <Option value="A+">A+</Option>
                        <Option value="A-">A-</Option>
                        <Option value="B+">B+</Option>
                        <Option value="B-">B-</Option>
                        <Option value="O+">O+</Option>
                        <Option value="O-">O-</Option>
                        <Option value="AB+">AB+</Option>
                        <Option value="AB-">AB-</Option>
                      </Select>
                    </Col>
                    {/*  Gender */}
                    <Col sm={24} md={8} className="mt-3">
                      <label className="font-semibold">Gender</label>
                      <Select
                        required
                        className="full-width mt-1"
                        placeholder="Select type"
                        onChange={(value) => setGender(value)}
                      >
                        <Option value="1">Male</Option>
                        <Option value="2">Female</Option>
                      </Select>
                    </Col>
                    {/* Passout Class */}
                    <Col sm={24} md={8} className="mt-3">
                      <label className="font-semibold">
                        School Passout Class (Year)
                      </label>
                      <Input
                        required
                        value={dropoutClass}
                        onChange={(e) => setDropoutClass(e.target.value)}
                        placeholder="Enter Passout Class"
                        className="mt-1"
                      />
                    </Col>
                    {/* Education */}
                    <Col sm={24} md={12} className="mt-3">
                      <label className="font-semibold">Education</label>
                      <Input
                        required
                        value={education}
                        onChange={(e) => setEducation(e.target.value)}
                        placeholder="Enter education"
                        className="mt-1"
                      />
                    </Col>
                    {/* Occupation */}
                    <Col sm={24} md={12} className="mt-3">
                      <label className="font-semibold">Occupation</label>
                      <Input
                        required
                        value={occupation}
                        onChange={(e) => setOccupation(e.target.value)}
                        placeholder="Enter occupation"
                        className="mt-1"
                      />
                    </Col>
                    {/* New Photo Upload */}
                    <Col sm={24} md={12} className="mt-3">
                      <label className="font-semibold">
                        Upload Student's New Photo *
                      </label>

                      <Input
                        key={fileKey} // 👈 This resets the input
                        className="full-width mt-1"
                        type="file"
                        accept="image/*"
                        onChange={(e) => {
                          const file = e.target.files[0]
                          if (!file) return

                          const maxSize = 8 * 1024 * 1024 // 1 MB

                          if (file.size > maxSize) {
                            toast.error('File size should be less than 8 MB')

                            // 👇 Force re-render input to clear selected file
                            setFileKey(Date.now())
                            return
                          }

                          setStudentNewImage(file)
                        }}
                      />
                    </Col>

                    {/* Old Photo Upload */}
                    <Col sm={24} md={12} className="mt-3">
                      <label className="font-semibold">
                        Upload Student's Old Photo *
                      </label>

                      <Input
                        key={fileKey} // 👈 This resets the input
                        className="full-width mt-1"
                        type="file"
                        accept="image/*"
                        onChange={(e) => {
                          const file = e.target.files[0]
                          if (!file) return

                          const maxSize = 8 * 1024 * 1024 // 1 MB

                          if (file.size > maxSize) {
                            toast.error('File size should be less than 8 MB')

                            // 👇 Force re-render input to clear selected file
                            setFileKey(Date.now())
                            return
                          }

                          setStudentOldImage(file)
                        }}
                      />
                    </Col>

                    {/*  Questions */}
                    <Col sm={24} md={12} className="mt-4">
                      <label className="font-semibold">
                        In what way will you be attending the Mahamaitra
                        Gathering?
                      </label>
                      <Select
                        required
                        className="full-width mt-1"
                        placeholder="Select type"
                        onChange={(value) => setWayOfAttending(value)}
                      >
                        <Option value="1">Residential</Option>
                        <Option value="2">Non-Residential</Option>
                      </Select>
                    </Col>

                    <Col sm={24} md={12} className="mt-4">
                      <label className="font-semibold">
                        What is the type of entry?
                      </label>
                      <Select
                        required
                        className="full-width mt-1"
                        placeholder="Select type"
                        onChange={(value) => setEntryType(value)}
                      >
                        <Option value="1">Day Learner</Option>
                        <Option value="2">Hostel</Option>
                      </Select>
                    </Col>

                    <Col sm={24} md={12} className="mt-4">
                      <label className="font-semibold">
                        Are you joining us for the Suvarna Mahotsavi Mahamaitra
                        Gathering (सुवर्ण महोत्सवी महामैत्र मेळा) on?
                      </label>
                      <Select
                        required
                        className="full-width mt-1"
                        placeholder="Select type"
                        onChange={(value) => setConfirmationForJoining(value)}
                      >
                        <Option value="1">24th & 25th January 2026</Option>
                        <Option value="2">Only 25th January 2026</Option>
                      </Select>
                    </Col>

                    <Col sm={24} md={12} className="mt-4">
                      <label className="font-semibold">
                        Will you be sending articles, memories, poems, stories
                        and incidents by 20th December 2025?
                      </label>
                      <Select
                        required
                        className="full-width mt-1"
                        placeholder="Select type"
                        onChange={(value) => setSendingArticlePoems(value)}
                      >
                        <Option value="1">Yes</Option>
                        <Option value="2">No</Option>
                      </Select>
                    </Col>

                    <Col sm={24} md={12} className="mt-4">
                      <label className="font-semibold">
                        Select House Number
                      </label>
                      <Select
                        required
                        className="full-width mt-1"
                        placeholder="Select house"
                        onChange={(value) => setHouseNo(value)}
                      >
                        <Option value="1">House 1</Option>
                        <Option value="2">House 2</Option>
                        <Option value="3">House 3</Option>
                        <Option value="4">House 4</Option>
                        <Option value="5">House 5</Option>
                        <Option value="6">House 6</Option>
                        <Option value="7">House 7</Option>
                        <Option value="8">House 8</Option>
                      </Select>
                    </Col>

                    <Col sm={24} className="mt-5">
                      {/* <label className="font-semibold">
                        ( For the Suvarna Mahotsavi Mahamaitra Gathering 2025
                        (सुवर्ण महोत्सवी महामैत्र मेळा), the two days
                        registration fee is Rs. 1000. Register before 31st
                        December to avail a discount of Rs. 200 and complete
                        your registration by paying Rs. 800 )*
                      </label> */}
                    </Col>

                    <Col sm={24} className="mt-4 text-end">
                      <Button
                        type="primary"
                        className="w-full"
                        onClick={handleNext}
                      >
                        Pay Now
                      </Button>
                    </Col>
                  </>
                )}

                {/* =============== STEP 2 — PAYMENT SECTION ==================== */}
                {step === 2 && (
                  <>
                    <Col md={24} className="mt-3 text-center">
                      <h3>
                        Registration Fee: <b> ₹ {registrationFee}</b>
                      </h3>
                      <p
                        style={{
                          fontSize: '14px',
                          marginTop: '5px',
                          color: '#fc6a6aff',
                        }}
                      >
                        {/* ( Note: Before 31 December the Registration Fee will be{' '}
                        <b>₹800</b>, and after 31 December the Registration Fee
                        will be <b>₹1000</b> ) */}
                      </p>
                    </Col>

                    <Col md={24} className="mt-3 text-center">
                      <div className="row text-start">
                        <h5>Account Details For Payment -</h5>
                      </div>

                      <div className="row m-0 pb-5 pb-md-2 px-md-3 shadow rounded border">
                        <div className="col-12 col-md-7 pt-4">
                          <div className="row">
                            <div className="col-4 text-start">
                              <p>
                                {' '}
                                <b> Account Holder's Name </b>{' '}
                              </p>
                            </div>
                            <div className="col-8 text-start">
                              <p>
                                - Shree Warana Vidyalaya Golden Jubilee
                                Committee
                              </p>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-4 text-start">
                              <p>
                                {' '}
                                <b> Account No. </b>{' '}
                              </p>
                            </div>
                            <div className="col-8 text-start">
                              <p>- Saving A/C. - 3970010800002498</p>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-4 text-start">
                              <p>
                                {' '}
                                <b> Bank Name </b>{' '}
                              </p>
                            </div>
                            <div className="col-8 text-start">
                              <p>- HDFC Bank</p>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-4 text-start">
                              <p>
                                {' '}
                                <b> Branch Name </b>{' '}
                              </p>
                            </div>
                            <div className="col-8 text-start">
                              <p>- Shree Warana Sahakari Bank Ltd.</p>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-4 text-start">
                              <p>
                                {' '}
                                <b> IFSC Code </b>
                              </p>
                            </div>
                            <div className="col-8 text-start">
                              <p>- HDFC OCSWSBL</p>
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-md-5 p-3 p-md-4">
                          <img
                            className="QRImage shadow"
                            src={QRImg}
                            alt="QR Code"
                          />
                          <br />

                          <a
                            href={QRImg}
                            download="QR_Code.png"
                            className="btn btn-primary py-1 mt-2"
                          >
                            Download QR
                          </a>

                        </div>
                      </div>
                    </Col>

                    <Col md={24} className="mt-3">
                      <label className="font-semibold">
                        Upload Payment Screenshot *
                      </label>

                      <Input
                        key={fileKey} // 👈 This resets the input
                        className="full-width mt-1"
                        type="file"
                        accept="image/*"
                        onChange={(e) => {
                          const file = e.target.files[0]
                          if (!file) return

                          const maxSize = 8 * 1024 * 1024 // 1 MB

                          if (file.size > maxSize) {
                            toast.error('File size should be less than 8 MB')

                            // 👇 Force re-render input to clear selected file
                            setFileKey(Date.now())
                            return
                          }

                          setPaymentScreenshot(file)
                        }}
                      />
                    </Col>

                    <Col md={24} className="mt-4 p-0">
                      <div className="row m-md-0">
                        <div className="col-12 col-md-6 mt-1 mt-md-0 text-center text-md-start">
                          <Button
                            type="default"
                            className="px-4 px-md-3 py-1 bg-dark text-white"
                            onClick={() => setStep(1)}
                          >
                            Back
                          </Button>
                        </div>

                        <div className="col-12 col-md-6 mt-2 mt-md-0 text-center text-md-end">
                          <Button
                            className="px-5 py-1"
                            type="primary"
                            disabled={!paymentScreenshot}
                            onClick={handleSubmit}
                          >
                            {loader ? 'Please wait...' : 'SUBMIT REGISTRATION'}
                          </Button>
                        </div>
                      </div>
                    </Col>
                  </>
                )}
              </Row>
            </Card>
          </div>
        </div>

        <div className="col-12 col-md-2"></div>
      </div>

      <Footer />
    </div>
  )
}

export default RegFeeForm
